<template>
  <el-container>
    <el-main>
      <div class="login_box">
        <el-form
          ref="loginFormRef"
          :model="loginForm"
          :rules="loginFormRules"
          label-width="10px"
          class="login_form"
        >
          <el-form-item prop="userName" >
            <el-input v-model.trim="loginForm.userName" placeholder="用户名" :prefix-icon="userIcon"></el-input>
          </el-form-item>
          <el-form-item  prop="password" >
            <el-input
              v-model.trim="loginForm.password"
              type="password"
              placeholder="密码"
              prefix-icon="iconfont icon-3702mima"
            ></el-input>
          </el-form-item>
          <el-form-item class="btns">
            <el-button type="primary" @click="login">{{$t('login.btn.login')}}</el-button>
            <el-button type="success" @click="resetPasswordShow">忘记密码</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-main>
    <el-dialog :visible.sync="resetPasswordDiag" title="密码重置" width="20%">
      <el-form :model="resetPasswordForm"
               ref="resetPasswordRef"
               :rules="resetPasswordRules"
               label-position="left">
        <el-form-item label="用户名" prop="userName">
          <el-input v-model="resetPasswordForm.userName" placeholder="请输入要重置的用户名"> </el-input>
        </el-form-item>
        <el-form-item label="手机号码" prop="mobile">
          <el-input v-model="resetPasswordForm.mobile" placeholder="请输入手机号码" > </el-input>
        </el-form-item>
        <el-form-item label="验证码" prop="smsCode">
          <el-input v-model="resetPasswordForm.smsCode" placeholder="请输入验证码" >
            <el-button slot="append" icon="el-icon" @click="requestSms">{{ resetPasswordText }}</el-button>
          </el-input>
        </el-form-item>
        <el-form-item label="新口令" prop="password">
          <el-input v-model.trim="resetPasswordForm.password" type="password" placeholder="请输入新密码"> </el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="resetPasswordDiag = false">取消</el-button>
        <el-button type="primary" @click="resetPassword">确认</el-button>
      </span>
    </el-dialog>
  </el-container>
</template>

<script>
import {deviceLogin, login, retrievePassword} from '@/api/sysUser'
import { guid } from '@/api/cookie'
import {checkLogin, isNotLogin} from '@/api/globalProcessErr'
import { listAllGpsDevice } from '@/api/gpsDevice'
import {
  batchMakeMarker,
  initMap,
  moveFirstPoint
} from '@/api/map'
import { deviceStatusFormat, getObjString, convertDateTimeToString } from '@/api/util'
import {sendSmsCode} from "@/api/smsCode";
import router from "@/router";

export default {
  data () {
    let checkSmsCode = (rule, value, callback) => {
      if (value === '') {
        return callback()
      }
      const regSms = /\d{6}$/
      if (regSms.test(value)) {
        // 合法邮箱
        return callback()
      }
      callback(new Error(this.$t('userPage.rules.email.legalEmail') + ''))
    }
    let checkMobile = (rule, value, callback) => {
      if (value === '') {
        return callback(new Error('手机号码不能为空'))
      }
      const regMobile = /^1\d{10}$/
      if (regMobile.test(value)) {
        // 合法邮箱
        return callback()
      }
      callback(new Error('手机号码不正确'))
    }
    return {
      loginForm: {
        userName: '',
        password: '',
        loginMode: 'userName',
        lang: ''
      },
      langList: [
        { key: 'zh-TW', label: '中文繁體' },
        { key: 'zh-CN', label: '中文简体' },
        { key: 'en-US', label: 'English' }
      ],
      center: {
        lat: 22.78,
        lng: 114
      },
      deviceList: [],
      devicePoints: [],
      deviceMarks: [],
      infoWindowList: [],
      mapInstance: undefined,
      openedDevice: undefined,
      userIcon: 'iconfont icon-user',
      currentMap: 'baidu',
      resetPasswordDiag: false,
      resetPasswordText: '获取验证码',
      smsRemainSeconds: 60,
      intervalId: undefined,
      resetPasswordForm: {

      },
      checkSmsCode: checkSmsCode,
      checkMobile: checkMobile,
    }
  },
  computed: {
    loginFormRules () {
      return {
        userName: [
          { required: true, message: this.$t('login.msg.rules.userName.required'), trigger: 'blur' },
          { min: 4, max: 30, message: this.$t('login.msg.rules.userName.required'), trigger: 'blur' }
        ],
        password: [
          { required: true, message: this.$t('login.msg.rules.password.required'), trigger: 'blur' },
          { min: 6, max: 30, message: this.$t('login.msg.rules.password.required'), trigger: 'blur' }
        ]
      }
    },
    resetPasswordRules () {
      return {
        password: [
          { required: true, message: this.$t('login.msg.rules.password.required'), trigger: 'blur' },
          { min: 6, max: 30, message: '口令长度为6到30个字符', trigger: 'blur' }
        ],
        mobile: [
          { required: true, message: '请输入用户对应的手机号码', trigger: 'blur' },
          { validator: this.checkMobile, trigger: 'blur' }
        ],
        smsCode: [
          { required: true, message: '请输入验证码', trigger: 'blur' },
          { validator: this.checkSmsCode, trigger: 'blur' }
        ],
        userName: [
          { required: true, message: '请输入用户名', trigger: 'blur' }
        ]
      }
    }
  },
  created () {
    this.checkLang()
  },
  mounted () {
    sessionStorage.removeItem('userName')
    sessionStorage.removeItem('token')
    sessionStorage.removeItem('userId')
  },
  methods: {
    checkLang () {
      let lang = 'zh-CN'

      if (lang === 'en-US') {
        this.center = {
          lat:25.037798,
          lng:121.565170
        }
        this.currentMap = 'google'
      } else if (lang === 'zh-CN') {
        this.center = {
          lat: 22.78,
          lng: 114
        }
        this.currentMap = 'baidu'
      } else {
        lang = 'zh-TW'
        this.center = {
          lat:25.037798,
          lng:121.565170
        }
        this.currentMap = 'google'
      }
      this.loginForm.lang = lang
      window.sessionStorage.setItem('lang', lang)
      this.$i18n.locale = lang
    },
    changeLoginMode () {
      this.userIcon = 'iconfont icon-user'
    },
    selectLang () {
      let lang = this.loginForm.lang
      if (lang === 'en-US') {
        this.center = {
          lat:25.037798,
          lng:121.565170
        }
        this.currentMap = 'google'
      } else if (lang === 'zh-CN') {
        this.center = {
          lat: 22.78,
          lng: 114
        }
        this.currentMap = 'baidu'
      } else {
        this.center = {
          lat:25.037798,
          lng:121.565170
        }
        lang = 'zh-TW'
        this.currentMap = 'google'
      }

      window.sessionStorage.setItem('lang', lang)
      this.$i18n.locale = lang
    },
    resetPasswordShow() {
      this.resetPasswordDiag = true
      this.resetPasswordForm = {
        userName: '',
        mobile: '',
        password: '',
        smsCode: ''
      }
      this.$nextTick(()=>{
        this.$refs.resetPasswordRef.resetFields();
      })
      if (this.intervalId){
        clearInterval(this.intervalId)
        this.smsRemainSeconds = 60
      }
      this.resetPasswordText = '获取验证码'
    },
    requestSms(){
      if (!this.resetPasswordForm.mobile){
        return this.$message.error('请输入手机号码')
      }

      const reg =  /^1\d{10}$/
      if (!reg.test(this.resetPasswordForm.mobile)){
        return this.$message.error('请输入正确的手机号码')
      }

      let self = this
      sendSmsCode(self.resetPasswordForm.mobile).then(res =>{
         if (res.data.code !== 0) {
           return self.$message.error(res.data.msg)
         }
        self.intervalResetAndRun()
      })
    },
    intervalResetAndRun(){
      let self = this
      self.resetPasswordText = String(self.smsRemainSeconds)
      self.intervalId = setInterval(function (){
        self.smsRemainSeconds --
        if (self.smsRemainSeconds < 0){
          clearInterval(self.intervalId)
          self.smsRemainSeconds = 60
          self.resetPasswordText = '获取验证码'
          self.resetPasswordForm.smsCode = ''
        } else {
          self.resetPasswordText = String(self.smsRemainSeconds)
        }
      },1000)
    },
    resetPassword() {
      let self = this
      this.$refs.resetPasswordRef.validate(async valid => {
        if (!valid) return
        retrievePassword(self.resetPasswordForm).then(res =>{
          if (res.data.code !== 0) {
            return self.$message.error(res.data.msg)
          }
          clearInterval(this.intervalId)
          self.smsRemainSeconds = 60
          self.resetPasswordDiag = false
          self.$message.success('已重置密码！')
        })
      })
    },
    motionStatusFormatter (row, column) {
      if (row.lastMotionStatus === 1) {
        return 'motion'
      } else if (row.lastMotionStatus === 0) {
        return 'static'
      } else {
        return ''
      }
    },
    login () {
      // 表单预验证
      // valid: bool类型
      const self = this
      this.$refs.loginFormRef.validate(async valid => {
        // console.log(valid)
        if (!valid) return false
        // this.$http.post('login', this.loginForm): 返回值为promise
        // 返回值为promise,可加await简化操作 相应的也要加async
        // const { data: res } = await this.$http.post('user/login', this.loginForm)
        const session = guid()
        window.sessionStorage.setItem('session', session)

        if (this.loginForm.loginMode === 'userName') {
          login(self.loginForm).then(res => {
            if (res.data.code !== 0) return this.$message.error(res.data.msg)

            this.$message.success(self.$t('login.msg.login.success'))
            // 1、将登陆成功之后的token, 保存到客户端的sessionStorage中; localStorage中是持久化的保存
            //   1.1 项目中出现了登录之外的其他API接口，必须在登陆之后才能访问
            //   1.2 token 只应在当前网站打开期间生效，所以将token保存在sessionStorage中
            window.sessionStorage.setItem('token', res.data.data.token)
            window.sessionStorage.setItem('userId', res.data.data.userId)
            window.sessionStorage.setItem('userName', res.data.data.userName)
            window.sessionStorage.setItem('selfCustomerId', res.data.data.customerId)
            window.sessionStorage.setItem('selfDeptId', res.data.data.deptId)
            self.$store.commit('setUserInfo', res.data.data)
            self.$store.commit('setToken', res.data.data.token)
            // 2、通过编程式导航跳转到后台主页, 路由地址为：/home
            self.$router.push('/home')
          })
        } else {
          const req = {
            deviceImei: self.loginForm.userName,
            password: self.loginForm.password
          }
          deviceLogin(req).then(res => {
            if (res.data.code !== 0) return this.$message.error(res.data.msg)
            this.$message.success(self.$t('login.msg.login.success'))
            // 1、将登陆成功之后的token, 保存到客户端的sessionStorage中; localStorage中是持久化的保存
            //   1.1 项目中出现了登录之外的其他API接口，必须在登陆之后才能访问
            //   1.2 token 只应在当前网站打开期间生效，所以将token保存在sessionStorage中
            window.sessionStorage.setItem('token', 'emptyToken')
            window.sessionStorage.setItem('userId', res.data.data[0][0].deviceId)
            window.sessionStorage.setItem('userName', res.data.data[0][0].deviceImei)
            window.sessionStorage.setItem('selfCustomerId', res.data.data[0][0].customerId)
            window.sessionStorage.setItem('selfDeptId', res.data.data[0][0].deptId)
            window.sessionStorage.setItem('device', JSON.stringify(res.data.data[0][0]))
            window.sessionStorage.setItem('pwdType', res.data.pwdType)
            self.$store.commit('setUserInfo', res.data.data[0][0])
            self.$store.commit('setToken', 'emptyToken')
            // self.$store.commit('setLang', self.loginForm.lang)
            // window.sessionStorage.setItem('lang', self.loginForm.lang)
            // 2、通过编程式导航跳转到后台主页, 路由地址为: /home
            self.$router.push('/home')
          })
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
  * {
    margin: 0;
    padding: 0;
  }
.el-container {
  height: 100% !important;
  background-image: url('../assets/first_page.jpg');
  background-repeat: no-repeat;
  background-size: cover;
}

.el-header {
  height: 8% !important;
}

.el-main {
  height: 84% !important;
  padding: 0 0 0 0;
}

.el-footer {
  background: #17848b;
  height: 8% !important;
}

.login_container {
  //background: url(../assets/1920x900.png) no-repeat;
  background-size: 100%;
  //border-bottom: 1px solid #000000;
  //background-color: #dae9fe;
  // position: relative;
  height: 100%;
}

.login_box {
  width: 250px;
  height: 170px;
  background-color: #fff;
  border-radius: 10px 10px 10px 10px;
  position: absolute;
  right: 0;
  top: 12%;
  border-top: 1px solid green;
  padding: 10px 10px 10px 10px !important;
  transform: translate(-20%, 0);
  -webkit-transform: translate(-30%, 0); // -150%
  background-color: #e3e3e5;

  .el-form {
    padding: 0px 10px 0px 0px !important;
    margin: 0 0 0 0 !important;
   /* margin-top: 0px !important;
    margin-bottom: 0px !important;
    margin-left: 0px !important;*/
    .el-radio-group {
      padding: 0 0 0 0 !important;
    }
    .el-form-item {
      margin: 0px !important;
      padding: 0px 0 20px 20px !important;
    }
  }
}

/* 媒体查询：针对小屏幕设备（如手机）的样式 */  
@media (max-width: 600px) {  
  .login_box {  
    width: 250px; /* 或者调整为适合手机屏幕的固定宽度 */  
    position: absolute;
    right: 0;
    top: 12%;
    border-top: 1px solid green;
    padding: 10px 10px 10px 10px !important;
    transform: translate(-20%, 0);
    -webkit-transform: translate(250%, 0); // -150%
    background-color: #e3e3e5;
  }  
}

.login_form {
  position: absolute;
  //top: 5%;
  left: -5%;
  width: 100%;
  padding: 5px 5px 5px 5px;
  box-sizing: border-box;
}

.el-button {
  //padding-left: 5px;
  //padding-right: 3px;
  padding: 10px 30px 10px 30px;
}

.btns {
  display: flex;
  justify-content: center;
}

.el-radio {
  color: #ffffff;
  font-weight: 700;
  margin-right: 15px;
}

.info {
  font-size: 13px;
  margin: 10px 15px;
}

.baidu-map {
  width: calc(100% - 10px);
  height: calc(100% - 10px);
  margin: 5px 5px 5px 5px;
}
</style>
